import { environment } from "@/environment/environment";
import axios from "axios";
import { loginRequest } from "./loginRequest";
import router from "@/router/router";
import { SupportQuestions } from "@/interfaces/types";
import { userData } from "@/data/userData";
import { storeToRefs } from "pinia";

const { apiUrl: baseUrl } = environment
const { getUserData } = loginRequest()


export function supportRequest() {

    const userStore = userData()
    const {user} = storeToRefs(userStore)
    
    const sendSupportEmail = async (firstName: string, lastName: string, email: string, phone: string, titleMessage: string, message: string): Promise<boolean> => {

        const data = await getUserData()
        if(!data){
            router.push('/landingPage')
            return false
        }
        try {
            const response = await axios.post(`${baseUrl}/support/sendEmail`,
                {
                    userId: data.id , firstName, lastName, email, phone, titleMessage, message
                });
            return response.data
        } catch (error) {
            console.log("🚀 ~ sendSupportEmail ~ error:", error)
            return false
        }
    };


    const getAllSupportQuestions = async (): Promise<SupportQuestions[]|null> => {
        try {
            const response = await axios.get(`${baseUrl}/support/getSupportQuestions`,{
                params: {userId: user.value.id}
            })
            const questions = response.data as SupportQuestions[]
            return questions
        } catch (error) {
            console.log("🚀 ~ getAllSupportQuestions ~ errors:", error)
            return null
        }
    }

    const reachBackend = async (): Promise<boolean> => {
        try {
            const response = await axios.get(`${baseUrl}/support/reachBackend`)
            return response.data
        } catch (error) {
            console.log("🚀 ~ reachBackend ~ errors:", error)
            return false
        }
    }

    return {
        sendSupportEmail,
        getAllSupportQuestions,
        reachBackend
    }
}